var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vendor-status-list",
      attrs: { slot: "content" },
      slot: "content",
    },
    [
      _c("table", [
        _c("thead", [
          _c("th", [_vm._v(_vm._s(_vm.$t("vendor.invitedVendors")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("vendor.onSiteVisitDateTime")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("vendor.status")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("handover.lastUpdateOn")))]),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.formattedBids, function (bid) {
            return _c("tr", { key: bid.id }, [
              _c("td", { staticClass: "vendor-name" }, [
                _vm._v("\n          " + _vm._s(bid.companyName) + "\n        "),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "visit-date row" }, [
                _vm._v("\n          " + _vm._s(bid.visitDate) + "\n        "),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "vendor-status" }, [
                _vm._v("\n          " + _vm._s(bid.status) + "\n        "),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "vendor-respond-date" }, [
                bid.lastSubmittedOn
                  ? _c("span", [_vm._v(_vm._s(bid.lastSubmittedOn))])
                  : _vm._e(),
              ]),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "status-summary" }, [
        _c("label", [_vm._v("SUBMITTED:")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.totalSubmittedbids))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }